(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class CategoryScrollShowcase extends HTMLElement {
    connectedCallback() {
      this.topTrack = this.querySelector('[data-scroll-track="top"]');
      this.bottomTrack = this.querySelector('[data-scroll-track="bottom"]');
      this.enabled = this.dataset.scrollEnabled !== 'false';
      this.maxShift = parseFloat(this.dataset.scrollSpeed) || 15;

      if (!this.enabled || !this.topTrack || !this.bottomTrack) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onScroll.bind(this);
      this.ticking = false;

      if (prefersReducedMotion.matches) {
        this.setProgress(0.5);
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      prefersReducedMotion.addEventListener('change', () => {
        if (prefersReducedMotion.matches) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
          this.setProgress(0.5);
        }
      });

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    getProgress() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollRange = viewportHeight + rect.height;
      const scrolled = viewportHeight - rect.top;

      return Math.max(0, Math.min(1, scrolled / scrollRange));
    }

    setProgress(progress) {
      const topTranslate = -progress * this.maxShift;
      const bottomTranslate = -(this.maxShift - progress * this.maxShift);

      this.topTrack.style.transform = `translate3d(${topTranslate}%, 0, 0)`;
      this.bottomTrack.style.transform = `translate3d(${bottomTranslate}%, 0, 0)`;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.setProgress(this.getProgress());
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('category-scroll-showcase')) {
    customElements.define('category-scroll-showcase', CategoryScrollShowcase);
  }
})();
